import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { whatsappActions } from '../actions/whatsapp';
import * as api from '../api/whatsapp';
const { whatsappGetApps, whatsappSetApps, whatsappGetIntegrations, whatsappSetIntegrations, whatsappSetAsyncStatus, whatsappUpdateIntegration, whatsappDeleteIntegration, whatsappSignup, } = whatsappActions;
export const whatsapp = [
    takeLatest(whatsappGetApps.toString(), getWhatsappIntegrations),
    takeEvery(whatsappGetIntegrations.toString(), genWithPromise(api.getIntegrations, whatsappSetAsyncStatus, whatsappSetIntegrations)),
    takeLatest(whatsappUpdateIntegration.toString(), genWithPromise(api.updateIntegration, whatsappSetAsyncStatus, whatsappGetApps)),
    takeLatest(whatsappDeleteIntegration.toString(), genWithPromise(api.deleteIntegration, whatsappSetAsyncStatus, whatsappGetApps)),
    takeLatest(whatsappSignup.toString(), genWithPromise(api.signup, whatsappSetAsyncStatus)),
];
function* getWhatsappIntegrations(action) {
    let result;
    yield put(whatsappSetAsyncStatus({ status: 'loading' }));
    try {
        result = yield call(api.getAppList, action.payload);
        yield call(action.meta.resolve, result);
        yield put(whatsappSetAsyncStatus({ status: 'succeeded' }));
        yield put(whatsappSetApps(result.data));
        for (let i = 0; i < result.data.applications.length; i += 1) {
            yield put(whatsappGetIntegrations({ appId: result.data.applications[i].app_id }));
        }
    }
    catch (exception) {
        console.warn(exception);
        // Something went wrong. We reject the promise.
        yield call(action.meta.reject, exception);
        result = exception;
        yield put(whatsappSetAsyncStatus({ status: 'failed' }));
    }
}
function genWithPromise(apiAction, statusAction, successAction) {
    return function* (action) {
        let result;
        yield put(statusAction({ status: 'loading' }));
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(statusAction({ status: 'succeeded' }));
            if (successAction) {
                yield put(successAction(result.data));
            }
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(statusAction({ status: 'failed' }));
        }
    };
}
